<template>
  <AddInvitation />
</template>

<script>
import AddInvitation from '../../../components/user/invitation'
export default {
  components: {
    AddInvitation,
  },
}
</script>

<style scoped lang="scss"></style>
